import React from 'react';

const styles = require('./footer-layout.styles.scss');


export class FooterLayout extends React.Component {
  render() {
    return (
      <div className={styles.FooterLayout}>
        { this.props.children }
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/layouts/footer/footer.layout.js